// src/modules/app-views/welcome/pages/Init/modals/FirstSubscriptionModal/Step3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert, Progress, Typography, Space } from 'antd';
import { CheckCircleOutlined, GiftOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import app from 'configs/appResolver';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const { Text } = Typography;
const WELCOME_CREDITS_BONUS = 100;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const Step3Content = ({ isPreparing, isCreating, isFinishing, isCompleted }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────

  // Show preparation state (0% progress, "Preparando...")
  if (isPreparing) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <Progress type="circle" percent={0} status="active" />
        <Text style={{ display: 'block', marginTop: 16 }}>{translateX('preparing')}</Text>
      </div>
    );
  }

  // Show progress while creating (75% progress, "Criando sua organização...")
  if (isCreating) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <Progress type="circle" percent={75} status="active" />
        <Text style={{ display: 'block', marginTop: 16 }}>
          {translateX('creating_your_organization')}
        </Text>
      </div>
    );
  }

  // Show finishing state (100% progress, "Finalizando...")
  if (isFinishing) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <Progress type="circle" percent={100} status="active" />
        <Text style={{ display: 'block', marginTop: 16 }}>{translateX('finishing')}</Text>
      </div>
    );
  }

  // Show success message when completed
  if (isCompleted) {
    return (
      <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
        <Alert
          type="success"
          showIcon
          icon={<CheckCircleOutlined />}
          title={translateX('welcome_to_system', { name: app?.NAME })}
          description={translateX('welcome_success_description', { name: app?.NAME })}
        />
        {/*<Alert*/}
        {/*  type="info"*/}
        {/*  showIcon*/}
        {/*  icon={<GiftOutlined />}*/}
        {/*  title={translateX('bonus_credits')}*/}
        {/*  description={translateX('welcome_credits_description', {*/}
        {/*    credits: WELCOME_CREDITS_BONUS,*/}
        {/*  })}*/}
        {/*/>*/}
      </Space>
    );
  }

  // Default state - should not normally be visible
  return (
    <div style={{ textAlign: 'center', padding: '40px 0' }}>
      <Progress type="circle" percent={0} />
      <Text style={{ display: 'block', marginTop: 16 }}>{translateX('preparing')}</Text>
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const stepDone = ({ isPreparing, isCreating, isFinishing, isCompleted, onEnterStep }) => ({
  stepTitle: 'finish',
  stepTooltip: 'complete_setup',
  content: () => (
    <Step3Content
      isPreparing={isPreparing}
      isCreating={isCreating}
      isFinishing={isFinishing}
      isCompleted={isCompleted}
    />
  ),
  nextButtonText: isCompleted ? 'start_using' : 'processing',
  nextButtonIcon: isCompleted ? <CheckCircleOutlined /> : null,
  // Auto-execute when entering this step
  onEnter: async ({ form }) => {
    if (onEnterStep) {
      await onEnterStep({ form });
    }
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default stepDone;
